import _ from 'lodash';
import { fromJsonArray } from 'src/core/utils';
import { MyOffer } from 'src/entities/offer/MyOffer';
import { Offer } from 'src/entities/offer/Offer';
import { getShoppingCart } from 'src/store/cart/selectors';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import { ParkedCartState } from './reducer';

/**
 * Fetch my offers
 */
export const getMyOffers = (state: any): EntityCollectionState<MyOffer> => {
    const data = state.myOffers;

    if (_.isEmpty(data)) return entityCollectionDefaultState<MyOffer>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(MyOffer, data.items),
    };
};

/**
 * Fetch offers
 */
export const getOffers = (state: any): EntityCollectionState<Offer> => {
    const data = state.offers;

    if (_.isEmpty(data)) return entityCollectionDefaultState<Offer>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(Offer, data.items),
    };
};

export const getParkedCart = (state: any): ParkedCartState => state.parkedCart ?? {};

/** R65 item 1: the cart holds the offer applyOffer loaded — it counts as empty until the parked goods return. */
export const holdsAppliedOffer = (state: any): boolean => {
    const { offerPublicId } = getParkedCart(state);
    if (!offerPublicId) return false;
    const cart = getShoppingCart(state).content;
    return cart.isOffer && cart.publicId === offerPublicId;
};
